import * as css from '../paymentForm/PaymentForm.css';
import {useTranslation} from 'react-i18next';
import SettingItem from '../settingItem/SettingItem';
import {useSelector} from 'react-redux';
import {Formik, Form} from 'formik';
import SubSettingItem from '../subSettingItem/SubSettingItem';
import DataItems from '../../../component/dataItems/DataItems';
import {updateEventSettingsList} from '../../../redux/event/eventActions';
import * as Yup from 'yup';
import {useState} from 'react';
import {createSettingInputs} from '../commonSettingInputs';
function SaleForm() {
    const {t} = useTranslation('event');
    const globalT = useTranslation('global').t;
    const blockOrder = useSelector(state => state.event.settings?.blockOrder);
    const settingsXHR = useSelector(state => state.forms.eventSettings);
    const crowdsData = useSelector(state => state.crowds.crowds); // Add crowds from redux
    const {getList, getToggle, getInput, getAmountInput} = createSettingInputs(blockOrder, 'blockOrder', settingsXHR, t);
    const [isCrowd, setIsCrowd] = useState(blockOrder?.fieldsCrowd?.length > 0);
    const limitList = [{key: 'orders', text: 'orders'}, {key: 'tickets', text: 'tickets'}];

    const initialValues = {
        limit: blockOrder?.limit,
        countLimit: blockOrder?.countLimit || 1,
        fids: blockOrder?.fids,
        fields: blockOrder?.fields,
        // crowd: blockOrder?.crowd,
        fieldsCrowd: blockOrder?.fieldsCrowd,
        isMemberLimit: blockOrder?.isMemberLimit || false,
        blockOrdersSms: blockOrder?.blockOrdersSms,
        blockOrdersSmsText: blockOrder?.blockOrdersSmsText || t('DefaultSmsText'),
    };
    const getCustomFieldsList = () => blockOrder?.fieldCustom?.map(item => {
        const selected = blockOrder?.fids?.some(i => i === item.fid);
        return {...item, key: item.fid, text: item.title, selected};
    });
    const getFields = () => {
        const fields = [
            {key: 'email', text: t('email')},
            {key: 'phone', text: t('phone')},
            (!isCrowd  && crowdsData?.length > 0) && {key: 'crowd', text: t('crowd')}
        ].filter(Boolean);

        let fieldsList = fields.map(item => {
            const selected = blockOrder?.fields?.includes(item.key);
            return {...item, selected};
        });
        let customFieldsList = getCustomFieldsList()||[];
        return fieldsList.concat(customFieldsList)||[];
    };

    const getCrowdsList = () => {
        const selectedCrowds = blockOrder?.fieldsCrowd || [];
        return crowdsData?.map(crowd => ({
            ...crowd,
            text: crowd.title,
            selected: selectedCrowds.includes(crowd.crid),
            key: crowd.crid
        }));
    };
    const onChange = (item, type) => {
        let serverValue;
        let name = ['phone', 'email', 'crowd'].includes(item.key) ? 'fields' : 'fids';
        const arr = blockOrder[name] || [];
        if(item.key!=='crowd'){
            if(type === 'add')
                serverValue = [...arr, item.key];
            else
                serverValue = arr.filter(i => i !== item.key);

            updateEventSettingsList(name, 'blockOrder', serverValue, serverValue);
        }
        else {
            setIsCrowd(true);
        }
    };

    const changeCrowds = (item, type) => {
        let serverValue;
        const arr = blockOrder['fieldsCrowd'] || [];        if(type === 'add')
            serverValue = [...arr, item.key];
        else {
            setIsCrowd(true);
            serverValue = arr.filter(i => i !== item.key);
        }

        updateEventSettingsList('fieldsCrowd', 'blockOrder', serverValue, serverValue);

    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={Yup.object().shape({countLimit: Yup.number().min(1)})}
            enableReinitialize={true}
            render={({values}) =>
                <Form>
                    <SettingItem settingCategory={'blockOrder'} name={'limit'}>
                        {getList('limit', limitList)}
                        {getAmountInput('countLimit', t(`${values.limit}Num`), globalT('pcs'), blockOrder?.isMemberLimit)}
                        <css.blockOrdersSmsText>
                            <SubSettingItem text={t('customerIdentification')}>
                                <DataItems
                                    list={getFields()}
                                    listText={t('fields')}
                                    icon="person"
                                    onChange={onChange}
                                />

                            </SubSettingItem>
                            {(blockOrder?.fieldsCrowd  && blockOrder?.fieldsCrowd ?.length > 0  || isCrowd )&& (

                                <SubSettingItem text={t('customerIdentification')}>

                                    {/* Show crowd selection only if 'crowd' is selected in fields */}
                                    <DataItems
                                        list={getCrowdsList()}
                                        listText={t('selectCrowd')}
                                        onChange={changeCrowds}
                                        icon="person"
                                        listWidth={'max-content'}
                                    />

                                </SubSettingItem>
                            )}
                        </css.blockOrdersSmsText>
                        {(blockOrder?.fieldsCrowd  && blockOrder?.fieldsCrowd ?.length > 0  || isCrowd) &&  getToggle('isMemberLimit')}
                        {getToggle('blockOrdersSms')}
                        <css.blockOrdersSmsText>
                            {getInput('blockOrdersSmsText')}
                        </css.blockOrdersSmsText>
                    </SettingItem>
                    <css.place />
                </Form>
            }
        />
    );
}

export default SaleForm;
